/* eslint-disable func-names */
import EDC from '../../../shared/globals';
import PreloaderScene from './preloader';
import MainScene from './main';
import { Thumbs } from '../../../shared/thumbs-animation';
import IngameMenuScene from '../../../shared/ingame-menu';

EDC.Games.CountByDragging.Scenes.Boot = function () {};

EDC.Games.CountByDragging.Scenes.Boot.prototype.init = function () {};

EDC.Games.CountByDragging.Scenes.Boot.prototype.create = function () {
  this.addStates();
  this.scene.start('preloader');
};

EDC.Games.CountByDragging.Scenes.Boot.prototype.addStates = function () {
  this.scene.add('preloader', PreloaderScene);
  this.scene.add('main', MainScene);
  this.scene.add('thumb', Thumbs);
  this.scene.add('ingame-menu', IngameMenuScene);
};

export default EDC.Games.CountByDragging.Scenes.Boot;
